<template>
  <modal :modal-key="'pending_challenge'" @close="$emit('close')" class="modal--welcomeback modal--zero-balance">
    <template slot="header">
      <h1>{{ getTranslations.home_pending_challenge_in_progress }}</h1>
    </template>
    <template slot="body">
      {{ getTranslations.home_pending_challenge_please_try_later }}
    </template>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';

export default {
  name: 'pending-challenge',
  components: {
    Modal,
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/challenge/PendingChallenge.vue